const linksEn = [
	{
		path: '/en/walk/',
		home: true,
	},
];

export default linksEn;
